import React, { Component, useRef } from 'react';
import '../StoreSelector.css';
import './NewStoreSelector.css';
import { setCursorStyle } from '../../../../utils/MouseUtilities.js';
import Segment from 'semantic-ui-react/dist/es/elements/Segment';
import 'semantic-ui-css/components/segment.min.css';
import 'semantic-ui-css/components/image.min.css';
import { Accordion } from 'semantic-ui-react';
import ReactHtmlParser from 'react-html-parser';
const hoverCursorStyle = 'pointer';
const unhoverCursorStyle = 'all-scroll';

import { NavigationMenuOptionClicked, WomanClicked, ManClicked, KidsClicked, SubCatClicked} from '../../../../utils/Analytics.js';
import SVGImage from '../../image-components/SVGImage';
import { getAllSceneInfoDictAsync } from '../../../../utils/StoreConfigManager';
import { AppContext } from '../../../../AppContext.jsx';
import { ThreeJSWorldContext } from 'web-store-modules/packages/web-store-three-world';
import MenuItem from './MenuItem';
import { getDirectoryMenu } from '../../../../utils/StaticAssetManager';
import { getCurrentScene } from '../../../../utils/History';

const dropDownArrowIcon = "https://cdn.obsess-vr.com/fendi/new-expand-arrow.png"
class CurrentStoreMenuItem extends Component {
    constructor(props) {
        super(props);

        this.onHover = this.onHover.bind(this);
        this.onUnhover = this.onUnhover.bind(this);
        this.onClick = this.onClick.bind(this);

        this.state = {
            jumpToFont: 'https://s3.amazonaws.com/obsessvr-webstore-assets-public/Caslon-BookItalic.otf',
            placeholderIconSrc: 'https://s3.amazonaws.com/obsessvr-webstore-assets-public/placeholder.svg',
            currentStoreMenuItemColor: '#7d7e7e',
            sections: [],
            activeIndex: '',
        }

    }

    componentDidMount() {
        this.getCurrentSceneId()
        this.setState({sections: getDirectoryMenu()})
    }

    getCurrentSceneId = () => {
        const { sceneIdNameDict, setCurrentScene } = this.props;
        const scene = getCurrentScene();
        if (sceneIdNameDict) {
            Object.keys(sceneIdNameDict).forEach((key) => {
                if (scene == sceneIdNameDict[key]) {
                    setCurrentScene(key)
                    this.setState({ selectedScene: key });
                }
            })
        }
    }


    onHover() {
        setCursorStyle(hoverCursorStyle);
    }

    onUnhover() {
        setCursorStyle(unhoverCursorStyle);
    }

    onClick(sceneId, tabName = "") {
        const { threeJSWorldContext, setLoadingIconVisibility, closeMenu } = this.props;
        setLoadingIconVisibility(true);
        closeMenu();
        getAllSceneInfoDictAsync()
            .then(sceneInfoDict => {
                if (!sceneInfoDict[sceneId]) {
                    throw new Error('Scene with id ' + sceneId + ' do not exist!');
                }

                const linkedSceneName = sceneInfoDict[sceneId]['name'];
                let targetPath = '/' + linkedSceneName;
                // NavigationMenuOptionClicked(linkedSceneName,tabName);

                if (threeJSWorldContext.history.location.pathname !== targetPath) {
                    threeJSWorldContext.pushHistoryWithReset(targetPath)
                } else {
                    this.props.setLoadingIconVisibility(false);
                }
            })
    }

    handleGAEvent = (type, name, parent) => {
        console.log(name, parent);
        if (type === 'Section') {
            switch (name) {
                case 'WOMAN':
                    WomanClicked();
                    break;
                case 'MAN':
                    ManClicked();
                    break;
                case 'KIDS':
                    KidsClicked();
                    break;
                default:
                    break;
                }
        } else if (type === 'Subsection') {
            SubCatClicked(parent, name)
        }
    }

    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index
        this.setState({ activeIndex: newIndex })
    }

    render() {
        const { currentStoreMenuItemColor, placeholderIconSrc, sections, activeIndex } = this.state;
        const { menuTextFontStyle, store, currentScene } = this.props;

        let style = Object.assign({}, menuTextFontStyle);
        let sceneStyle = Object.assign({}, menuTextFontStyle);

        style.color = currentStoreMenuItemColor;
        
        const routeRenders = sections.map((scene, index) => (
            <Accordion key={index}>
                <React.Fragment key={index}>
                    {scene.isHeader ?
                        <Accordion.Title
                            active={activeIndex === index}
                            index={index}
                            onClick={this.handleClick}
                            style={{ width: '115%' }}
                        >
                            <li className='linked-store-scene' onClick={() => {scene.type ? this.openModal(scene.type) : scene.redirecturl ? this.redirectTo(scene.redirecturl) : scene.sceneId && !scene.haveItems && this.onClick(scene.sceneId, ""); this.handleGAEvent('Section', scene.name, scene.name)}}>
                                <span
                                    className={(currentScene === scene.sceneId && scene.sceneId != '' ? 'active-section' : '')}
                                    onMouseOver={this.onHover}
                                    onMouseOut={this.onUnhover}
                                    onClick={() => scene.sceneId && this.onClick(scene.sceneId, "")}
                                > {ReactHtmlParser(scene.name)}</span>
                                {scene.haveItems ?
                                    <img src={dropDownArrowIcon}
                                        className="dropdown-arrow-style"
                                        style={{ transform: activeIndex === index ? 'rotate(360deg)' : '' }} /> : ''
                                }
                            </li>
                        </Accordion.Title>
                        : ""
                    }
                    {scene.submenu &&
                        scene.submenu.map((item, i) => {
                            return item &&
                                <Accordion.Content active={activeIndex === index} >
                                    <li className='linked-store-subsection' onClick={() => {item.sceneId && this.onClick(item.sceneId, scene.name ); this.handleGAEvent('Subsection', item.name, scene.name)}}>
                                        <span
                                            className={(currentScene === item.sceneId && item.sceneId != '' ? 'active-section' : '')}
                                            onMouseOver={this.onHover}
                                            onMouseOut={this.onUnhover}
                                        > {item.name}</span>
                                    </li>
                                </Accordion.Content>
                        })
                    }
                </React.Fragment>
            </Accordion>
        ));


        return (
            <Segment className="overflow-auto">
                <div className="text-align-left float-left">
                <ul className="selector">
                    {routeRenders}
                </ul>
                </div>
                <div
                    style={{ float: 'right', marginTop: '-0.5em' }}
                >
                </div>
            </Segment>
        );
    }
}

CurrentStoreMenuItem.propTypes = {
    closeMenu: PropTypes.func,
    menuTextFontStyle: PropTypes.object,
    store: PropTypes.object,
    setLoadingIconVisibility: PropTypes.func
};

export default props => (
    <AppContext.Consumer>
        {appContextValue => (
            <ThreeJSWorldContext.Consumer>
                {threeJSWorldContext => (
                    <CurrentStoreMenuItem
                        {...props}
                        threeJSWorldContext={threeJSWorldContext}
                        setLoadingIconVisibility={appContextValue.setLoadingIconVisibility}
                        setCurrentScene={appContextValue.setCurrentSceneName}
                        currentScene={appContextValue.currentScene}

                    />
                )}
            </ThreeJSWorldContext.Consumer>
        )}
    </AppContext.Consumer>
);
